
import { defineComponent, ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
import { Modal, notification } from "ant-design-vue";
import { useRouter } from "vue-router";
import { h } from "vue";

export default defineComponent({
  components: {},

  setup() {
    const filterOption = (inputValue: any, option: any) => {
      return option.children.join('').toLowerCase().includes(inputValue.toLowerCase());
    }

    const router = useRouter();
    const form_action = ref("save");
    const store = useStore();

    const fields = ref([
      {
        title: "Invoice No.",
        dataIndex: "invoice_number",
        fixed: true,
      },
      {
        title: "IBPS Transaction Number",
        dataIndex: "transaction_number",
        fixed: true,
      },
      {
        title: "Invoice Date",
        dataIndex: "mvw_ap.invoice_date",
      },
      {
        title: "PO Number",
        dataIndex: "po_number",
      },
      {
        title: "Due Date",
        dataIndex: "due_date",
      },
      {
        title: "Invoice Status",
        dataIndex: "invoice_description",
      },
      {
        title: "Requestor",
        dataIndex: "requester",
      },
      {
        title: "PV No.",
        dataIndex: "pv_number",
      },
      {
        title: "Check No.",
        dataIndex: "check_number",
      },
      {
        title: "Check Date",
        dataIndex: "check_date",
      },
      {
        title: "Paid Amount",
        dataIndex: "paid_amount",
      },
      {
        title: "Bank Releasing Branch",
        dataIndex: "bank",
      },
      {
        title: "Check Status",
        dataIndex: "invoice_description",
      },
      // {
      //   title: "Action",
      //   dataIndex: "action",
      //   slots: { customRender: "action" },
      //   align: "center",
      // },
    ]);
    const option_org = ref([
        {"value":"396","label":'Therma Luzon, Inc.'},
        {"value":"1169","label":'Therma South, Inc.'},
        {"value":"2190","label":'Therma Visayas, Inc.'},
    ])
    const option_vendors = ref([]);


    const form = reactive({
        id:'',
        org_id: '',
        vendor_id: '',
        invoice_no: '',
        view:''
    })
      
    
    const index = () => {
       store.dispatch('Option/getAllVendors')
    };

    const editRecord = (record: any) => {
      router.push({ path: "/invoice/edit/" + record.id });
    };

    const deleteRecord = (record: any) => {
      store.dispatch("VendorInvoice/destroy", record.id);
    };

    const handleSaving = () => {
        store.dispatch("PaymentStatusPortal/index", form)
    }

    // onMounted(() => {

    //   // index();
    // });

    const items = computed(() => store.getters["PaymentStatusPortal/items"]);
    const loading = computed(() => store.getters["PaymentStatusPortal/status"]);

    return {
      items,
      loading,
      fields,
      form_action,
      option_vendors,
      option_org,
      form,
      editRecord,
      deleteRecord,
      handleSaving,
      filterOption
    };
  },
});
